import React from 'react';

export const CloudIcon = () => (
  <svg
    className="weather-icon"
    height="32px"
    version="1.1"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g fill="#000000">
        <path d="M7.10100919,15.1021544 C5.32460991,15.5117359 4,17.1046097 4,19 C4,21.209139 5.79793835,23 8.00281647,23 L24.9971835,23 C27.207878,23 29,21.2046438 29,19 C29,17.1225574 27.70144,15.5472159 25.9581226,15.1164746 L25.9581226,15.1164746 C25.9857342,14.9149284 26,14.7091302 26,14.5 C26,12.0147185 23.9852815,10 21.5,10 C20.2744589,10 19.1633432,10.489913 18.3518132,11.2845787 C17.3608691,9.33540592 15.336385,8 13,8 C9.68629134,8 7,10.6862913 7,14 C7,14.3764904 7.03467626,14.7448817 7.10100919,15.1021544 L7.10100919,15.1021544 L7.10100919,15.1021544 Z M26.9993494,14.4145295 C28.7676457,15.1852931 30,16.9483386 30,19 C30,21.7558048 27.7616745,24 25.0005601,24 L7.99943992,24 C5.23249418,24 3,21.7614237 3,19 C3,16.9491311 4.23965876,15.1816085 6.01189661,14.4115388 L6.01189661,14.4115388 C6.00400207,14.275367 6,14.1381509 6,14 C6,10.1340066 9.13400656,7 13,7 C15.2979469,7 17.3372745,8.10728055 18.6135384,9.81739735 C19.4525719,9.29909701 20.441357,9 21.5,9 C24.5090248,9 26.9536744,11.4163763 26.9993494,14.4145295 L26.9993494,14.4145295 L26.9993494,14.4145295 Z" />
      </g>
    </g>
  </svg>
);
